// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"361":"413acaf94b171481","529":"15ef01274d5ed507"}[chunkId] + ".js";
};